import { GenericFieldFactory } from "../_generics/GenericFieldFactory";

export const InitialUrlStore = GenericFieldFactory("INITIAL_URL", null);